import { Params } from "./genesis";
import { Coin } from "../../../base/v1beta1/coin";
import { BinaryReader, BinaryWriter } from "../../../../binary";
function createBaseMsgConvertERC20() {
    return {
        contractAddress: "",
        amount: "",
        receiver: "",
        sender: ""
    };
}
export const MsgConvertERC20 = {
    typeUrl: "/cosmos.evm.erc20.v1.MsgConvertERC20",
    encode(message, writer = BinaryWriter.create()) {
        if (message.contractAddress !== "") {
            writer.uint32(10).string(message.contractAddress);
        }
        if (message.amount !== "") {
            writer.uint32(18).string(message.amount);
        }
        if (message.receiver !== "") {
            writer.uint32(26).string(message.receiver);
        }
        if (message.sender !== "") {
            writer.uint32(34).string(message.sender);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConvertERC20();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.contractAddress = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                case 3:
                    message.receiver = reader.string();
                    break;
                case 4:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseMsgConvertERC20();
        message.contractAddress = object.contractAddress ?? "";
        message.amount = object.amount ?? "";
        message.receiver = object.receiver ?? "";
        message.sender = object.sender ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgConvertERC20();
        if (object.contract_address !== undefined && object.contract_address !== null) {
            message.contractAddress = object.contract_address;
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = object.amount;
        }
        if (object.receiver !== undefined && object.receiver !== null) {
            message.receiver = object.receiver;
        }
        if (object.sender !== undefined && object.sender !== null) {
            message.sender = object.sender;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.contract_address = message.contractAddress === "" ? undefined : message.contractAddress;
        obj.amount = message.amount ?? "";
        obj.receiver = message.receiver === "" ? undefined : message.receiver;
        obj.sender = message.sender === "" ? undefined : message.sender;
        return obj;
    },
    fromAminoMsg(object) {
        return MsgConvertERC20.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "cosmos/evm/MsgConvertERC20",
            value: MsgConvertERC20.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgConvertERC20.decode(message.value);
    },
    toProto(message) {
        return MsgConvertERC20.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/cosmos.evm.erc20.v1.MsgConvertERC20",
            value: MsgConvertERC20.encode(message).finish()
        };
    }
};
function createBaseMsgConvertERC20Response() {
    return {};
}
export const MsgConvertERC20Response = {
    typeUrl: "/cosmos.evm.erc20.v1.MsgConvertERC20Response",
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConvertERC20Response();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseMsgConvertERC20Response();
        return message;
    },
    fromAmino(_) {
        const message = createBaseMsgConvertERC20Response();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return MsgConvertERC20Response.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "cosmos-sdk/MsgConvertERC20Response",
            value: MsgConvertERC20Response.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgConvertERC20Response.decode(message.value);
    },
    toProto(message) {
        return MsgConvertERC20Response.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/cosmos.evm.erc20.v1.MsgConvertERC20Response",
            value: MsgConvertERC20Response.encode(message).finish()
        };
    }
};
function createBaseMsgConvertCoin() {
    return {
        coin: Coin.fromPartial({}),
        receiver: "",
        sender: ""
    };
}
export const MsgConvertCoin = {
    typeUrl: "/cosmos.evm.erc20.v1.MsgConvertCoin",
    encode(message, writer = BinaryWriter.create()) {
        if (message.coin !== undefined) {
            Coin.encode(message.coin, writer.uint32(10).fork()).ldelim();
        }
        if (message.receiver !== "") {
            writer.uint32(18).string(message.receiver);
        }
        if (message.sender !== "") {
            writer.uint32(26).string(message.sender);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConvertCoin();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.coin = Coin.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.receiver = reader.string();
                    break;
                case 3:
                    message.sender = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseMsgConvertCoin();
        message.coin = object.coin !== undefined && object.coin !== null ? Coin.fromPartial(object.coin) : undefined;
        message.receiver = object.receiver ?? "";
        message.sender = object.sender ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgConvertCoin();
        if (object.coin !== undefined && object.coin !== null) {
            message.coin = Coin.fromAmino(object.coin);
        }
        if (object.receiver !== undefined && object.receiver !== null) {
            message.receiver = object.receiver;
        }
        if (object.sender !== undefined && object.sender !== null) {
            message.sender = object.sender;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.coin = message.coin ? Coin.toAmino(message.coin) : undefined;
        obj.receiver = message.receiver === "" ? undefined : message.receiver;
        obj.sender = message.sender === "" ? undefined : message.sender;
        return obj;
    },
    fromAminoMsg(object) {
        return MsgConvertCoin.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "cosmos-sdk/MsgConvertCoin",
            value: MsgConvertCoin.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgConvertCoin.decode(message.value);
    },
    toProto(message) {
        return MsgConvertCoin.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/cosmos.evm.erc20.v1.MsgConvertCoin",
            value: MsgConvertCoin.encode(message).finish()
        };
    }
};
function createBaseMsgConvertCoinResponse() {
    return {};
}
export const MsgConvertCoinResponse = {
    typeUrl: "/cosmos.evm.erc20.v1.MsgConvertCoinResponse",
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgConvertCoinResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseMsgConvertCoinResponse();
        return message;
    },
    fromAmino(_) {
        const message = createBaseMsgConvertCoinResponse();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return MsgConvertCoinResponse.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "cosmos-sdk/MsgConvertCoinResponse",
            value: MsgConvertCoinResponse.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgConvertCoinResponse.decode(message.value);
    },
    toProto(message) {
        return MsgConvertCoinResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/cosmos.evm.erc20.v1.MsgConvertCoinResponse",
            value: MsgConvertCoinResponse.encode(message).finish()
        };
    }
};
function createBaseMsgUpdateParams() {
    return {
        authority: "",
        params: Params.fromPartial({})
    };
}
export const MsgUpdateParams = {
    typeUrl: "/cosmos.evm.erc20.v1.MsgUpdateParams",
    encode(message, writer = BinaryWriter.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.params !== undefined) {
            Params.encode(message.params, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.params = Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseMsgUpdateParams();
        message.authority = object.authority ?? "";
        message.params = object.params !== undefined && object.params !== null ? Params.fromPartial(object.params) : undefined;
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgUpdateParams();
        if (object.authority !== undefined && object.authority !== null) {
            message.authority = object.authority;
        }
        if (object.params !== undefined && object.params !== null) {
            message.params = Params.fromAmino(object.params);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.authority = message.authority === "" ? undefined : message.authority;
        obj.params = message.params ? Params.toAmino(message.params) : Params.toAmino(Params.fromPartial({}));
        return obj;
    },
    fromAminoMsg(object) {
        return MsgUpdateParams.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "cosmos/evm/x/erc20/MsgUpdateParams",
            value: MsgUpdateParams.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgUpdateParams.decode(message.value);
    },
    toProto(message) {
        return MsgUpdateParams.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/cosmos.evm.erc20.v1.MsgUpdateParams",
            value: MsgUpdateParams.encode(message).finish()
        };
    }
};
function createBaseMsgUpdateParamsResponse() {
    return {};
}
export const MsgUpdateParamsResponse = {
    typeUrl: "/cosmos.evm.erc20.v1.MsgUpdateParamsResponse",
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgUpdateParamsResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseMsgUpdateParamsResponse();
        return message;
    },
    fromAmino(_) {
        const message = createBaseMsgUpdateParamsResponse();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return MsgUpdateParamsResponse.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "cosmos-sdk/MsgUpdateParamsResponse",
            value: MsgUpdateParamsResponse.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgUpdateParamsResponse.decode(message.value);
    },
    toProto(message) {
        return MsgUpdateParamsResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/cosmos.evm.erc20.v1.MsgUpdateParamsResponse",
            value: MsgUpdateParamsResponse.encode(message).finish()
        };
    }
};
function createBaseMsgRegisterERC20() {
    return {
        authority: "",
        erc20addresses: []
    };
}
export const MsgRegisterERC20 = {
    typeUrl: "/cosmos.evm.erc20.v1.MsgRegisterERC20",
    encode(message, writer = BinaryWriter.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        for (const v of message.erc20addresses) {
            writer.uint32(18).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRegisterERC20();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.erc20addresses.push(reader.string());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseMsgRegisterERC20();
        message.authority = object.authority ?? "";
        message.erc20addresses = object.erc20addresses?.map(e => e) || [];
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgRegisterERC20();
        if (object.authority !== undefined && object.authority !== null) {
            message.authority = object.authority;
        }
        message.erc20addresses = object.erc20addresses?.map(e => e) || [];
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.authority = message.authority === "" ? undefined : message.authority;
        if (message.erc20addresses) {
            obj.erc20addresses = message.erc20addresses.map(e => e);
        }
        else {
            obj.erc20addresses = message.erc20addresses;
        }
        return obj;
    },
    fromAminoMsg(object) {
        return MsgRegisterERC20.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "cosmos/evm/x/erc20/MsgRegisterERC20",
            value: MsgRegisterERC20.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgRegisterERC20.decode(message.value);
    },
    toProto(message) {
        return MsgRegisterERC20.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/cosmos.evm.erc20.v1.MsgRegisterERC20",
            value: MsgRegisterERC20.encode(message).finish()
        };
    }
};
function createBaseMsgRegisterERC20Response() {
    return {};
}
export const MsgRegisterERC20Response = {
    typeUrl: "/cosmos.evm.erc20.v1.MsgRegisterERC20Response",
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgRegisterERC20Response();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseMsgRegisterERC20Response();
        return message;
    },
    fromAmino(_) {
        const message = createBaseMsgRegisterERC20Response();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return MsgRegisterERC20Response.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "cosmos-sdk/MsgRegisterERC20Response",
            value: MsgRegisterERC20Response.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgRegisterERC20Response.decode(message.value);
    },
    toProto(message) {
        return MsgRegisterERC20Response.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/cosmos.evm.erc20.v1.MsgRegisterERC20Response",
            value: MsgRegisterERC20Response.encode(message).finish()
        };
    }
};
function createBaseMsgToggleConversion() {
    return {
        authority: "",
        token: ""
    };
}
export const MsgToggleConversion = {
    typeUrl: "/cosmos.evm.erc20.v1.MsgToggleConversion",
    encode(message, writer = BinaryWriter.create()) {
        if (message.authority !== "") {
            writer.uint32(10).string(message.authority);
        }
        if (message.token !== "") {
            writer.uint32(18).string(message.token);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgToggleConversion();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.authority = reader.string();
                    break;
                case 2:
                    message.token = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseMsgToggleConversion();
        message.authority = object.authority ?? "";
        message.token = object.token ?? "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgToggleConversion();
        if (object.authority !== undefined && object.authority !== null) {
            message.authority = object.authority;
        }
        if (object.token !== undefined && object.token !== null) {
            message.token = object.token;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.authority = message.authority === "" ? undefined : message.authority;
        obj.token = message.token === "" ? undefined : message.token;
        return obj;
    },
    fromAminoMsg(object) {
        return MsgToggleConversion.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "cosmos/evm/x/erc20/MsgToggleConversion",
            value: MsgToggleConversion.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgToggleConversion.decode(message.value);
    },
    toProto(message) {
        return MsgToggleConversion.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/cosmos.evm.erc20.v1.MsgToggleConversion",
            value: MsgToggleConversion.encode(message).finish()
        };
    }
};
function createBaseMsgToggleConversionResponse() {
    return {};
}
export const MsgToggleConversionResponse = {
    typeUrl: "/cosmos.evm.erc20.v1.MsgToggleConversionResponse",
    encode(_, writer = BinaryWriter.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgToggleConversionResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(_) {
        const message = createBaseMsgToggleConversionResponse();
        return message;
    },
    fromAmino(_) {
        const message = createBaseMsgToggleConversionResponse();
        return message;
    },
    toAmino(_) {
        const obj = {};
        return obj;
    },
    fromAminoMsg(object) {
        return MsgToggleConversionResponse.fromAmino(object.value);
    },
    toAminoMsg(message) {
        return {
            type: "cosmos-sdk/MsgToggleConversionResponse",
            value: MsgToggleConversionResponse.toAmino(message)
        };
    },
    fromProtoMsg(message) {
        return MsgToggleConversionResponse.decode(message.value);
    },
    toProto(message) {
        return MsgToggleConversionResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/cosmos.evm.erc20.v1.MsgToggleConversionResponse",
            value: MsgToggleConversionResponse.encode(message).finish()
        };
    }
};
//# sourceMappingURL=tx.js.map